// Copyright 2019 Sorama B.V.

import { Range as IRange } from "datatypes/SoramaLocalApi";
import { IWorkflowPropertyParser } from "libraries/WorkflowFramework/Interfaces/IWorkflowPropertyParser";

export class RangeParser implements IWorkflowPropertyParser<IRange> {
    toWorkflowProperty(object: IRange): string {
        if (object == undefined || object.from == undefined || object.to == undefined) {
            return "";
        }

        return object.from.toFixed(2) + "," + object.to.toFixed(2);
    }

    fromWorkflowProperty(str: string): IRange {
        const vals = str.split(",");
        return <IRange>{
            from: Number(vals[0]),
            to: Number(vals[1]),
        };
    }
}
